import { SortOrder } from 'primereact/api'

/**
 * Sort an array of objects by a given field.
 *
 * @param {Array<Object>} values - Array of objects to sort.
 * @param {string} sortField - Name of the field to sort by.
 * @param {number} [sortOrder=SortOrder.ASC] - Sort direction (`SortOrder.ASC` or `SortOrder.DESC`).
 * @returns {Array<Object>} A new, sorted array.
 */
export function sortValues(values, sortField, sortOrder = SortOrder.ASC) {
  return [...values].sort((a, b) => {
    if (a[sortField] < b[sortField]) return -sortOrder
    if (a[sortField] > b[sortField]) return sortOrder
    return 0
  })
}
